import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import WebCamera from "../WebCamera";
import { useMessage } from "../../base/MessageProvider";

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  width: "90%",
  bgcolor: "white",
  paddingX: 5,
  paddingY: 3,
  borderRadius: "18px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const ImageUploadOptions = ({
  title,
  open,
  onClose,
  onSubmit,
  hideCamera = false,
  hideGallery = false,
  allowMultiple = false,
}) => {
  const [cameraOpen, setCameraOpen] = useState(false);

  const inputRef = useRef(null);
  const alert = useMessage();

  useEffect(() => {
    if (open) setCameraOpen(false);
  }, [open]);

  const handleSubmit = async (data) => {
    // if (data[0].size > 20000000) {
    //     alert.showInfo("Image must be less than or equals to 20MB");
    //     onClose();
    //     return;
    // }
    onSubmit(data);
    onClose?.();
  };

  const handleClickGallery = () => {
    inputRef.current?.click();
  };

  const handleChangeImages = (e) => {
    e.preventDefault();
    if (e.target.files?.length >= 1) {
      const images = e.target.files;
      console.log(images);
      if (images.length > 10) {
        alert.showInfo("You can select upto 10 images only");
        onClose();
        return;
      }
      if (
        images.length > 1 &&
        Array.from(images).find((item) => item.size > 10000000)
      ) {
        alert.showInfo(
          "Some images are rejected, since there size are greater that 10MB"
        );
      }
      if (images.length === 1 && images[0].size > 20000000) {
        alert.showInfo("Image must be less than or equals to 20MB");
        onClose();
        return;
      }
      const finalImages = Array.from(images).filter(
        (item) => item.size <= 10000000
      );
      if (finalImages?.length <= 0) return;
      handleSubmit([...finalImages]);
    }
  };

  return (
    <Modal
      disableAutoFocus
      sx={{ bgcolor: "#F4F4F499" }}
      hideBackdrop
      open={open}
    >
      <Box className="shadow-[0_0_14px_grey]" sx={boxStyle}>
        <IconButton
          onClick={onClose}
          className="absolute top-3 right-3"
          size="small"
        >
          <Close className="text-xl" />
        </IconButton>
        <Box className="mb-6">
          <h2 className="font-['Poppins-Medium'] font-[500] text-center text-[16px]">
            {title ?? "Select image to upload"}
          </h2>
        </Box>
        <Stack className="w-full" my={1}>
          <input
            ref={inputRef}
            className="hidden"
            type="file"
            id="image-file"
            multiple={allowMultiple}
            onChange={handleChangeImages}
            accept="image/png, image/jpeg"
          />
          {!hideGallery && (
            <Button
              onClick={handleClickGallery}
              className="bg-[#2F80ED] text-[#FFF] w-full rounded-full my-2 font-['Poppins-Medium'] font-[500]"
            >
              Select media from gallery
            </Button>
          )}
          {!hideCamera && (
            <Button
              onClick={setCameraOpen?.bind(null, true)}
              className="bg-[#2F80ED] text-[#FFF] w-full rounded-full my-2 font-['Poppins-Medium'] font-[500]"
            >
              Use camera
            </Button>
          )}
        </Stack>
        <WebCamera
          open={cameraOpen}
          onClose={setCameraOpen?.bind(null, false)}
          onSubmit={handleSubmit}
        />
      </Box>
    </Modal>
  );
};

export default React.memo(ImageUploadOptions, (prevProps, nextProps) => {
  return prevProps.open === nextProps.open;
});
